<template>
  <bg-yun>
    <div style="display: none">
      <slot></slot>
    </div>

    <div style="position: relative;" class="bg-white bgyunc">
      <img src="./gou-01.svg" width="20" v-show="order.check>0" class="order_identifying" alt="">
      <div class="parent-content flex-layout">
        <div  class="div_img">
          <img :src="order.picPath" width="120px" height="auto" onerror="this.src='static/image/error.jpg'"
               alt="" style=" pointer-events: none;">
        </div>
        <div class="flex-1 height94 order-warray" >
          <div class="order">
            <div class="flex-1 text-left magin-t-4 color-black font-0-9-5 order_name">
              {{order.name}} <img height="18" :src="icon" v-for="icon in order.iconPath">
            </div>
            <div class="text-right color-yellow margin-l-10 padding-r-10 magin-t-4" style="width: auto">
              <div><span class="font-0-7"></span><span class="font-1-1 ">{{order.price}}<span class="font-0-6">元</span></span></div>
              <div class="color-blue magin-t-4">
                <img v-if="order.memberprice &&order.price>order.memberprice" src="./vipIco.svg" alt="" width="18" class="vip-img">
                <span v-if="order.memberprice &&order.price>order.memberprice">
                <!--<span class="font-0-7">￥</span>-->
                <span class="font-1-1 ">{{order.memberprice}}<span class="font-0-6">元</span></span>
                </span>
              </div>
            </div>
          </div>

          <div class="height40 font-0-8 color-gray magin-t-6" v-if="order.desc">
            {{order.desc}}
          </div>
          <div class="height40 font-0-8 color-gray magin-t-6" v-if="!order.desc">
            暂无菜品描述
          </div>
          <div class="saleout" v-if="order.isSaleout">
            <img src="./soldout.svg" width="65">
          </div>
        </div>
      </div>
    </div>
  </bg-yun>
</template>

<script>
  import bgyun from "../bg-yun/bgyun";
  export default {
    data () {
      return{
      }
    },
    components:{
      'bg-yun':bgyun
    },

    watch:{
      'order.num'(){
        console.log(new Date());
      }
    },

    props: {
      order: {}, //定义传值的类型
      type:{},
      parent:{},
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .font-0-6{font-size: 0.6em;}
  .text-left{text-align: left;}
  .magin-t-4{margin-top: 4px;}
  .text-right{text-align: right;}
  .color-yellow{color:#FF6D00}
  .font-0-7{font-size: 0.7em;}
  .margin-l-10{
    margin-left: 10px;
  }
  .font-0-8{font-size: 0.8em;}
  .vip-img{vertical-align: middle;padding-bottom: 4px;}
  .font-1-1{font-size: 1.1em;}
  .color-blue{color:#00ABF8}
  .color-gray{color:#9e9e9e}
  .padding-r-10{
    padding-right: 10px;
  }
  .magin-t-6{
    margin-top: 6px;
  }
  .parent-content{height: 100px;margin: auto;}
  .flex-layout{ display: flex;  align-items: center;}
  .height40{height: 40%;overflow: hidden;}
  .height94{height: 94px;}
  .saleout{position: absolute;bottom:20px;left:9%;}
  .order_name{justify-content: flex-start;align-items: flex-start}
  .order-warray{position: relative;display:flex; flex-direction: column;justify-content: space-between;}
  .div_img{width: 120px;height: 94px;overflow: hidden;display: flex;border-radius: 5px;margin: 0 8px 0 8px}
  .div_img img{width: 120px;align-self: center;border-radius: 5px}
  .order{justify-content: flex-start; display: flex; flex-direction: row; align-items: flex-start;}
  .bg-white{background:#ffffff}
  .flex-1{flex:1;overflow:hidden;width: 0}
  .flex-3{flex:3;overflow:hidden;width: 0}
  .color-black{color:#000000}
  .font-0-9-5{font-size: 0.95em;}
  .order_identifying{position: absolute;top: 0;right: 0;color: #fff;border-width: 10px;}
  .bgyunc{border: 1px solid #eeeeee;border-radius: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/smallPicModel/smallPicMode.vue